export default __webpack_public_path__ + "static/media/city_loc.a84c25f0.png";